import { createSlice } from '@reduxjs/toolkit';
import { RFIDService } from '_apis_/rfid';
import { dispatch } from '../store';
import { IRfidListParams, RfidModel } from '../../@types/rfid';

const rfidService = new RFIDService();
type rfidState = {
  isLoading: boolean;
  error: boolean;
  rfidList: RfidModel[];
  rfidListCount: number;
  addSuccessMsg: string;
  currentRfid: any;
};
const initialState: rfidState = {
  isLoading: true,
  error: false,
  rfidList: [],
  rfidListCount: 0,
  addSuccessMsg: '',
  currentRfid: null
};

const rfidSlice = createSlice({
  name: 'rfid',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
      state.addSuccessMsg = '';
      state.error = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // RESET INIT STATE
    resetState(state) {
      state.currentRfid = null;
    },
    // GET ONE RFID SUCCESS
    getRfidSuccess(state, action) {
      state.isLoading = false;
      state.currentRfid = action.payload;
    },
    // GET all/search RFIDs SUCCESS
    getRfidListSuccess(state, action) {
      state.isLoading = false;
      state.rfidList = action.payload.content;
      state.rfidListCount = action.payload.totalElements;
    },

    // update RFID
    updateRfidSuccess(state) {
      state.isLoading = false;
      state.addSuccessMsg = 'RFID updated';
    },

    // Add RFID
    addRfidSuccess(state) {
      state.isLoading = false;
      state.addSuccessMsg = 'RFID Added';
    }
  }
});

export function resetRfidState() {
  return async () => {
    dispatch(rfidSlice.actions.resetState());
  };
}
export function getRfid(rfid) {
  return async () => {
    dispatch(rfidSlice.actions.startLoading());
    try {
      const response = await rfidService.getRfidCard(rfid);
      const data = response.data;
      dispatch(rfidSlice.actions.getRfidSuccess(data));
    } catch (error) {
      dispatch(rfidSlice.actions.hasError(error));
    }
  };
}

export function getRfidList(params: IRfidListParams) {
  return async () => {
    dispatch(rfidSlice.actions.startLoading());
    try {
      const response = await rfidService.getRfidCards(params);

      const data = response.data;
      dispatch(rfidSlice.actions.getRfidListSuccess({ ...data }));
    } catch (error) {
      dispatch(rfidSlice.actions.hasError(error));
    }
  };
}

export function addRfid(value) {
  return async () => {
    dispatch(rfidSlice.actions.startLoading());
    try {
      await rfidService.submitRfid(value);
      dispatch(rfidSlice.actions.addRfidSuccess());
    } catch (error) {
      dispatch(rfidSlice.actions.hasError(error));
    }
  };
}

export function updateRfid(value) {
  return async () => {
    dispatch(rfidSlice.actions.startLoading());
    try {
      await rfidService.submitRfid(value, true);
      dispatch(rfidSlice.actions.updateRfidSuccess());
    } catch (error) {
      dispatch(rfidSlice.actions.hasError(error));
    }
  };
}

// Reducer
export default rfidSlice.reducer;
